<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">IRISH RAILWAYS</h1>
<div class="title-image"><img alt="Image" src="images/line.jpg"/></div>
<h1 class="subtitle"><span class="small-text">IN THE</span> 1950<span class="small-text">S AND</span> 1960<span class="small-text">S</span></h1>
<p class="subtitle-1">A JOURNEY THROUGH TWO DECADES</p>
<p class="author">KEVIN M<span class="small1">C</span>CORMACK</p>
<div class="img_container"><img alt="Image" src="images/Img_0003-01.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?0377cd7e